import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=5190c161&scoped=true"
import script from "./Funds.vue?vue&type=script&lang=js"
export * from "./Funds.vue?vue&type=script&lang=js"
import style0 from "./Funds.vue?vue&type=style&index=0&id=5190c161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190c161",
  null
  
)

export default component.exports